<!--
__________________________________________________
Summary 
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Vue component for displaying "popup" status messages.

General usage of this component will not need to specify inline properties on the component. 
Most use cases will involve directly invoking showStatus and hideStatus functions. 

__________________________________________________
Properties
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
title -   optional, a title to be displayed in bold above the message.
          This parameter can be overwritten with the isWarning parameter of showStatus method.

          warning - optional, determines whether the message should be displayed with warning background color.
          This parameter can be overwritten with the isWarning parameter of showStatus method.

__________________________________________________
Methods
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾

showStatus(msg, statusTitle, isWarning, startDelay, duration, customClass)
Shows a popup status box with the message and title specified,
only msg is required, all other parameters are optional


hideStatus()
Hides the popup, if it's currently showing - no parameters

__________________________________________________
Usage
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Register the status component in the template entry-point of your application, including 'ref="statusMessage"': 
<status ref="statusMessage"></status>

From javascript within any Vue components, you can reference showStatus 
and hideStatus methods via the $root.$refs.statusMessage handle:
this.$root.$refs.statusMessage.showStatus('yowza!')
this.$root.$refs.statusMessage.hideStatus()


-->

<template>
  <transition :duration="{ enter: 400, leave: 300 }" name="slide-fade">
    <div v-show="isShowing==true" 
      class="alert alert-dismissable status-container" 
      :class="[alertClass]"
    >
      <a href="#" class="close" @click.prevent.stop="isShowing=false" aria-label="close" style="left: 0px;">&times;</a>
      <span v-show="false" class="glyphicons glyphicons-ok-circle mr-2" style="margin-left:-18px;"></span>
      <span v-html="(alertTitle) ? alertTitle : ''" class="font-weight-semibold" style="font-size: 1.25em;"></span><br v-show="(alertTitle)">
      <span v-html="alertMessage" class="font-normal"></span>
    </div>
  </transition>    
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },    
    warning: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.status.statusOptions,
    }),    
  },
  data: function () {
    return {
      timeoutVar: false, // used to store handle to setTimeout calls
      isWarning: this.warning,
      isShowing: false,
      alertMessage: '',
      alertTitle: '',
      alertClass: 'alert-yellow'
    }
  },
  watch: {
    statusOptions: function(options){
      console.log("watch: statusOptions")
      if (options){
        this.showStatus(options);
      }
    }
  },
  mounted(){
    // listen for invocations on event bus
    this.$eventBus.$on("showStatus", (params) => {
      this.showStatus(params);
    });
  },
  methods: {
    showStatus: function(options) {
      //this.hideStatus();
      let msg = (options.msg) ? options.msg : options; // if not an object with .msg prop, expects string
      var isWarning = (options.isWarning!=undefined) ? options.isWarning : (this.warning ? this.warning : false);
      var duration = (options.duration) ? options.duration : (isWarning ? 18000 : 8000); // default message time is 8 seconds, 18 if we are displaying a warning
      var startDelay = (options.startDelay) ? options.startDelay : 0;
      var statusTitle = (options.title) ? options.title : (this.title ? this.title : '');
      var activeClass = 'alert-';
      
      if (!isWarning && !options.customClass) {
        activeClass += 'primary';
      } else if (isWarning && !options.customClass) {
        activeClass += 'warning';
      } else {
        activeClass += options.customClass;
      }
    
      if (this.timeoutVar!=null) {
        clearTimeout(this.timeoutVar);
        this.timeoutVar = null;
      }

      let that = this;
      var showPopup = function() {
        that.alertMessage = msg.toString();
        that.alertTitle = statusTitle;
        that.isWarning = isWarning;
        that.isShowing = true;
        that.alertClass = activeClass;
        if (duration != -1) {
          that.timeoutVar = setTimeout(function(){that.isShowing=false},duration);
        }
      }

      console.log(that.isShowing)
      setTimeout(showPopup,startDelay);

    },

    hideStatus: function() {
      if (this.timeoutVar!=null) {
        clearTimeout(this.timeoutVar);
        this.timeoutVar = null;
      }
      this.isShowing = false;
    }

  },
}
</script>

<style>

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.1, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(50px);
    opacity: 0;
  }

  .status-container {
    box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.25);
  }
</style>